import { toggleElement, typeahead } from "@pod-point/pod-point-ui-toolkit";

const tableName = "dynamic-table";

class DynamicTable {
  index = 0;
  token = "";
  controller = "";

  constructor({ index, token, controller }) {
    this.index = index;
    this.token = token;
    this.controller = controller || "pricing-group-assignment-row";
  }

  removeRowItem(event) {
    event.target.closest("tr").remove();
  }

  async getGroupRows(group) {
    try {
      const response = await fetch(
        `/admin/${this.controller}/groups/${group}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": this.token,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch row.");
      const result = await response.text();

      const existingGroupRows = document.querySelectorAll(
        `#${tableName} tbody tr[readonly]`
      );
      existingGroupRows.forEach((row) => {
        row.remove();
      });

      const tableBody = document.querySelector(`#${tableName} tbody`);
      tableBody.insertAdjacentHTML("afterBegin", result);

      const tooltipButtons = document.querySelectorAll(
        "[data-js-module='toggleElement']"
      );
      tooltipButtons.forEach((dropdown) => {
        toggleElement.init(dropdown);
      });
    } catch (error) {
      console.error("Error getting rows:", error);
    }
  }

  async addRowItem() {
    try {
      const response = await fetch(
        `/admin/${this.controller}?index=${this.index}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-CSRF-TOKEN": this.token,
          },
        }
      );

      if (!response.ok) throw new Error("Failed to fetch row.");
      const result = await response.text();

      /**
       * Add the new row to the table
       */
      const tableBody = document.querySelector(`#${tableName} tbody`);
      tableBody.insertAdjacentHTML("beforeend", result);


      /**
       * Add event listener to the delete button
       */
      document
        .getElementById(`delete-row-btn-${this.index}`)
        .addEventListener("click", this.removeRowItem);

      /**
       * Initialise the typeahead for the select dropdowns
       */
      const newRow = tableBody.rows[tableBody.rows.length - 1];
      const selectDropdowns = newRow.querySelectorAll(
        "[data-js-module='typeahead']:not([disabled])"
      );
      selectDropdowns.forEach((dropdown) => {
        typeahead.init(dropdown);
      });

      this.index++;

      const event = new CustomEvent("dynamic-table:row-added", {
        detail: {
          row: newRow,
        },
      });
      document.dispatchEvent(event);
    } catch (error) {
      console.error("Error adding row:", error);
    }
  }
}

export default DynamicTable;

document.addEventListener("DOMContentLoaded", () => {
  const table = document.getElementById(tableName);
  if (!table) return;

  const controller = table.getAttribute("data-controller");

  const token = document.getElementsByName("_token")[0].value;
  const rowCount = table.querySelectorAll("tbody tr").length;
  const dt = new DynamicTable({ index: rowCount, token, controller });

  document.querySelectorAll("#add-row-btn").forEach((button) => {
    button.addEventListener("click", dt.addRowItem.bind(dt));
  });

  // This is specific to pricing groups, and ensures when the group_id is changed,
  // we fetch the pricing group assignments for the group.
  document.querySelectorAll("#group_id").forEach((select) => {
    select.addEventListener("change", (event) => {
      dt.getGroupRows(event.target.value);
    });
  });

  document.querySelectorAll("[id^='delete-row-btn-']").forEach((button) => {
    button.addEventListener("click", dt.removeRowItem.bind(dt));
  });
});
